import { usePalette } from "@/components/calm/Calm";
import { F } from "@/lib/bricks";
import { homeServicesFor } from "@/lib/homeServices";

// Quiet list of home services for a client type. Each opens the one quote
// form on www.brxs.ca/services with that trade picked. Text links only: the
// screen's primary button stays whatever booking it already has.
export default function HomeServicesList({ kind, title = "Home services, by quote", testid = "home-services" }) {
  const { p } = usePalette();
  const list = homeServicesFor(kind);
  if (!list.length) return null;
  return (
    <section data-testid={testid} style={{ borderTop: `1px solid ${p.hair}`, paddingTop: 14, fontFamily: F.display }}>
      <div style={{ fontSize: 12.5, fontWeight: 500, color: p.ink3, marginBottom: 2 }}>{title}</div>
      <div style={{ fontSize: 12, color: p.ink3, marginBottom: 8 }}>A person at Bricks quotes it in writing. Nothing is booked until you approve.</div>
      <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column" }}>
        {list.map((s) => (
          <li key={s.slug} style={{ borderTop: `1px solid ${p.hair}` }}>
            <a href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`hs-${s.slug}`}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, minHeight: 44, padding: "6px 0", color: p.ink, textDecoration: "none" }}>
              <span style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: 13.5 }}>{s.name}</span>
                <span style={{ fontSize: 12, color: p.ink3 }}>{s.line}</span>
              </span>
              <span style={{ fontSize: 12.5, color: p.ink2, whiteSpace: "nowrap", textDecoration: "underline", textUnderlineOffset: 3, textDecorationColor: p.hairS }}>Request a quote</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
